export default __webpack_public_path__ + "static/media/763.35940072.png";